import React from 'react';
import cn from 'classnames';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import theme from '../../../../../theme';
import styles from '../item.module.scss';

const stubColumns = () => (
  <div className={styles.col}>
    <div className={styles.topLine} style={{ color: theme.palette.mantra.pink, fontSize: '18px' }}>
      --
    </div>
  </div>
);

const Stub = ({ icon, subIcons, token }) => {
  const colors = useGetTheme();
  const getWrapBgColor = () => ({ style: { backgroundColor: colors.listAssetBackground } });
  const getTitleColor = () => ({ style: { color: colors.text } });

  return (
    <div className={cn(styles.wrap, styles.default)} {...getWrapBgColor()}>
      <div className={styles.col}>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={icon} alt='' />
          {subIcons.length > 0 && (
            <div className={styles.subIcons}>
              {subIcons.map((src) => (
                <img className={styles.subIconsItem} key={src} src={src} alt='' />
              ))}
            </div>
          )}
        </div>
        <div className={styles.stakeBalance}>
          <p className={styles.topLine} {...getTitleColor()}>
            {token} 0.00
          </p>
          <p className={styles.bottomLine}>$0.00</p>
        </div>
      </div>
      {stubColumns()}
      {stubColumns()}
      {stubColumns()}
      {stubColumns()}
    </div>
  );
};

Stub.defaultProps = {
  subIcons: [],
};

export default Stub;
